import { render, staticRenderFns } from "./uploadRechargeImg.vue?vue&type=template&id=37484b7c&scoped=true&"
import script from "./uploadRechargeImg.vue?vue&type=script&lang=js&"
export * from "./uploadRechargeImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadRechargeImg.vue?vue&type=style&index=0&id=37484b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37484b7c",
  null
  
)

export default component.exports